import axios from "axios";
import React from "react";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import ExclusionValueUpdateForm from "../../../elements/ServiceExclusions/ExclusionValueUpdateForm";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";

const ServiceExclusionItem = ({ exclusion, t, notification, setNotification, setFetch }) => {

  const {
    name,
    service
  } = exclusion;

  const remove = () => {
    axios.delete(`/api/service-exclusions/${exclusion.id}`, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_NO_CONTENT) {
        setFetch(prevState => !prevState);
        setNotification({ ...notification, visible: true, type: "success", message: t("exclusions.successDelete") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }

  return (
    <StyledTableRow
      scroll="auto"
      col="4"
      className="service-exclusion-table__row"
    >
      <StyledCol>
        {getServiceNameWithNickname(service.name, service.nickname)}
      </StyledCol>
      <StyledCol>
        {t(`exclusions.names.${name}`)}
      </StyledCol>
      <StyledCol>
        <ExclusionValueUpdateForm
          exclusion={exclusion}
          t={t}
          notification={notification}
          setNotification={setNotification}
          setFetch={setFetch}
        />
      </StyledCol>
      <StyledCol>
        <button
          className="table-action table-action_info"
          onClick={remove}
        >
          <span className="icon-light-cancel" />
          {t("exclusions.editForm.delete")}
        </button>
      </StyledCol>
    </StyledTableRow>
  );
};

export default ServiceExclusionItem;